import React, { useState, useEffect, useContext, useRef } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import commonContext from '../../custom/context/common/commonContext'
import './StaticPages.css'
import UserContext from '@/product/context/user/userContext'
import { mapData } from '@/product/common/components'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: '10px',
    },
}))(MuiAccordionDetails)
const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#fff',
        marginBottom: -1,
        minHeight: 40,
        '&$expanded': {
            minHeight: 40,
        },
    },
    content: {
        '&$expanded': {
            margin: '0',
        },
    },
    expanded: {},
})(MuiAccordionSummary)

const Faq = (props) => {
    const [expanded, setExpanded] = useState()
    const [faq, setFaq] = useState([])
    const accordionRefs = useRef([])
    const userContext = useContext(UserContext)
    const [disable, setDisable] = useState(false)
    const history = useHistory()
    const { submitContactUs, responseStatus } = userContext
    const customCommonContext = useContext(commonContext)
    const { allfaq } = customCommonContext
    useEffect(() => {
        if (allfaq && allfaq.length) {
            const data = allfaq
                .filter((faq) => faq.active === 1)
                .map((faq) => ({ title: faq.question, details: faq.description, id: faq.id }))
            console.log(data, 'dataa')
            setFaq(data)
        }
    }, [allfaq])

    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'submitContactUs') {
                if (responseStatus.status === 'success') {
                    setDisable(false)
                    handleRedirectInternal(history, 'search')
                }
            }
        }
    }, [responseStatus])

    // useEffect(() => {
    //     if (props.match.params.id) {
    //         formik.handleReset()
    //         console.log(props.match.params.id, 'igg')
    //         const index = parseInt(props.match.params.id)
    //         const panelId = `panel${index}`
    //         setExpanded(panelId)

    //         // Scroll to the Accordion after a short delay to allow DOM update
    //         setTimeout(() => {
    //             if (accordionRefs.current[index]) {
    //                 accordionRefs.current[index].scrollIntoView({
    //                     behavior: 'smooth',
    //                     block: 'start',
    //                 })
    //             }
    //         }, 100) // Adjust the delay as needed
    //     }
    // }, [props.match.params.id])

    const handleChange = (panel) => (event, newExpanded) => {
        formik.handleReset()
        setExpanded(newExpanded ? panel : false)
    }

    const containerRef = useRef(null)

    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email address').required('Email is required'),
        message: Yup.string().required('Required'),
        description: Yup.string().required('Description is required'),
    })

    const formik = useFormik({
        initialValues: {
            email: '',
            message: '',
            description: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log('Form submitted:', values)
            setDisable(true)
            submitContactUs(values)
        },
    })

    const claimForm = [
        {
            label: 'Your Email',
            placeholder: 'Enter your email address',
            name: 'email',
            type: 'text',
            formik: formik,
        },
        {
            label: 'Please enter Lot',
            placeholder: 'Enter Lot',
            name: 'description',
            type: 'text',
            formik: formik,
        },
        {
            label: 'Description',
            placeholder: 'Please describe the nature of your Claim',
            name: 'message',
            type: 'textarea',
            formik: formik,
        },
    ]
    const inquiryForm = [
        {
            label: 'Your Email',
            placeholder: 'Enter your email address',
            name: 'email',
            type: 'text',
            formik: formik,
        },
        {
            label: 'Brief Description',
            placeholder: '',
            name: 'description',
            type: 'text',
            formik: formik,
        },
        {
            label: 'Description',
            placeholder: 'Please enter detailed information regarding your enquiry',
            name: 'message',
            type: 'textarea',
            formik: formik,
        },
    ]

    console.log(faq, 'allfaq')

    const static_faq = [
        {
            title: 'I visited your website and now I want to buy an asset. How do I buy it?',
            details:
                'We are happy you found something of your use in our inventory. The first step towards purchasing is to get registered. You can buy from Portal sale, Insta Sale, or auctions. For buying from Auction, you need to participate in our online bidding events.',
            id: 1,
        },
        {
            title: 'Can I buy an asset before auction starts?',
            details:
                'No, we don’t practice advance selling. Absolutely nothing is sold beyond bidding. Each asset is sold to the highest bidder on the day of bidding.',
            id: 2,
        },
        {
            title: 'Do I have to place a deposit before I bid?',
            details:
                'Yes, at the time of auction registration, you are required to deposit an amount which is EMD (Earnest Money Deposit). This is completely refundable in case you are not the H1 bidder post closure of auction.',
            id: 3,
        },
        {
            title: 'I was a successful bidder. Where and how can I collect my asset which I had won?',
            details:
                'Successful Bidders are fully responsible for taking delivery of all Vehicle(s) or Equipment from the concerned seller, details of which will be confirmed by your respective Relationship Manager after full payment is made. No vehicle / equipment must be removed by the Successful Customer until all dues are paid in full and realized by the seller/Owner. He/she must remove his vehicle(s)/ equipment as per the T&C which has been mentioned in the auction catalogue in which he has participated.',
            id: 4,
        },
        {
            title: 'What is iQuippo’s refund policy in case I am an unsuccessful bidder?',
            details: `If a registered bidder does not purchase a vehicle or equipment, the EMD will be refunded immediately after the bidding process is completed, provided the customer has submitted all relevant documents (KYC, cancelled cheque, etc.).
    <ul>
      
      <li>Any payment received via online mode (online payment gateway) will be refunded to the source account from which the payment was made, <b>within 48 hours</b>.</li>
      <li>For offline transfers by iQuippo (via cheque or online transfer), the following details are required: IFSC code, account number, bank name, bank branch name, bank branch code, beneficiary name (must match ID proof provided), and ID/address proof (as given during registration).</li>
      <li>The bidder’s name in the bank account must match the name in the ID proof.</li>
      <li>EMD for successful bidders will be refunded only after the full sale amount is received and confirmed by the seller, applicable service charges are adjusted (if any), and a refund request is raised by the customer.</li>
    </ul>
  `,
            id: 5,
        },

        {
            title: 'I am not happy with the asset which I had purchased. What can I do now?',
            details:
                'Bidders should physically inspect the vehicle(s) and/or equipment before buying. Dispute pertaining to year of manufacture, documents, condition of vehicle/assets, etc. will not be considered after successful bid. The inspection can be done by any bidder or his authorized representative.',
            id: 6,
        },

        {
            title: 'How many times can I bid in an auction?',
            details:
                'We hold two types of auctions: Normal and Bid limit. Normal auctions allow the bidder to bid an unlimited number of times, whereas bid limit auctions limit the number of bids per lot, which is displayed in the "Bid Now" screen.',
            id: 7,
        },

        {
            title: 'What all documents are required for registration?',
            details:
                'For registration the bidder must present copy of PAN Card (mandatory) and Address Proof document i.e., Passport or Driving License or Voter’s ID or Adhaar Card in case he is registering in Individual capacity. However, if the bidder is registering in the capacity of Legal Entity, then PAN Card & GST Certificate of the entity would be required.',
            id: 8,
        },

        {
            title: 'If I am a successful bidder, what are the service charges which I need to pay?',
            details:
                'The successful Bidder will have to pay iQuippo a buyer’s premium as mentioned in the auction catalogue. The buyer’s premium is not negotiable and must be payable on all acquisitions as the case maybe.',
            id: 9,
        },

        {
            title: 'What is the payment policy? ',
            details:
                'All acquisitions made by the Successful Bidder are subject to applicable GST and other statutory tax applicable and RTO charges as per law in force, and the same are payable by the Successful Bidder as per the T&C mentioned in the auction catalogue. Successful bidder has to pay the full sale proceeds as per the T&C mentioned in the auction catalogue to Seller/Owner. Failure to do so the bid submitted by him will be considered as Null & Void and EMD amount will be forfeited without further intimation.*',
            id: 10,
        },

        {
            title: 'I am not happy with the asset which I had purchased. What can I do now?',
            details: 'PAN Card, GST Registration, Adhaar Card, Address Proof, Cancelled Cheque.',
            id: 6,
        },
    ]

    return (
        <div>
            <section className="homeFAQ homeMarginBottom pt-1 pb-2">
                <div className="faqAccordion">
                    {static_faq.map((data, index) => (
                        <Accordion
                            square
                            expanded={expanded === `panel${index}`}
                            key={index}
                            onChange={handleChange(`panel${index}`)}
                            ref={(el) => (accordionRefs.current[index] = el)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1d-content"
                                id={`panel${index}d-header`}
                            >
                                <h6 className="accTitle">{data.title}</h6>
                                {console.log(data, 'data123')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <p
                                    ref={containerRef}
                                    dangerouslySetInnerHTML={{
                                        __html: data.details,
                                    }}
                                ></p>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            </section>
        </div>
    )
}

export default Faq
